module.exports = __webpack_public_path__ + "static/node-ba796a0e34af6c0ec2f6ed9dfba2d439.png";